import { MODAL_ROUTES } from "routing/routes";

import { useGetRedirectAuthenticatedUserToLocationMatches } from "./useGetRedirectAuthenticatedUserToLocationMatches";

export function useIsChildAddParentByCodeSignIn() {
  return useGetRedirectAuthenticatedUserToLocationMatches(
    MODAL_ROUTES.ADD_PARENT.path
  );
}
